<template>
    <v-container fluid>

        <div class="centered-content mt-sm-8 mt-md-12">

            <!--Alertes-->
            <v-snackbar bottom color="error" dark v-model="authFailed">
                Votre mot de passe est incorrect, ou aucun utilisateur n'existe pour cette adresse email.
            </v-snackbar>

            <v-alert border="left" colored-border elevation="2" transition="slide-y-transition" type="success"
                     v-model="isResentResetCodeSuccess">
                <div>Si cette adresse email est bien enregistrée auprès de nos services, vous recevrez un email vous
                    permettant de mettre à jour votre mot de passe.
                </div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="isResentResetCodeSuccess=!isResentResetCodeSuccess" text>OK</v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <v-alert border="left" colored-border elevation="2" transition="slide-y-transition" type="info"
                     v-model="forgotPasswordAlert">
                <div>Avez-vous oublié votre mot de passe ?</div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="$router.push({name:'forgot', params:{email:login}})" text>Réinitialiser mon mot
                            de passe
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <v-alert border="left" colored-border elevation="2" transition="slide-y-transition" type="warning"
                     v-model="userIsInPasswordRecovery">
                <p>Une demande de ré-initialisation de mot de passe a été réalisée pour ce compte. Veuillez consulter
                    votre boite mail et suivre les instructions données. </p>
                <p>Si vous n'avez pas reçu d'email, n'oubliez pas de regarder dans votre courrier indésirable, ou
                    demandez à renvoyer un nouvel email de ré-initialisation de mot de passe.</p>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn :loading="resendingResetCode"
                               @click="$router.push({name:'forgot', params:{email:login}})" text>Renvoyer un nouvel
                            email
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <v-alert border="left" colored-border elevation="2" transition="slide-y-transition" type="warning"
                     v-model="userIsBlocked">
                <div>Ce compte utilisateur a été bloqué par un nombre trop élevé de tentatives de connexion.</div>
                <div>Veuillez contacter le <a href="https://support.yodaforex.com">support Yodaforex</a>.</div>
<!--                <v-row align="center" class="mt-2" no-gutters>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-col class="shrink">-->
<!--                        <v-btn @click="" text>Débloquer mon compte</v-btn>-->
<!--                    </v-col>-->
<!--                </v-row>-->
            </v-alert>


            <v-alert border="left" elevation="2" transition="slide-y-transition" type="error" v-model="unknownError">
                <div>Une erreur est survenue. Si le problème persiste, contactez le <a
                        href="https://support.yodaforex.com">support Yodaforex</a></div>
                <v-row align="center" class="mt-2" no-gutters>
                    <v-spacer></v-spacer>
                    <v-col class="shrink">
                        <v-btn @click="authenticate" text>Réessayer</v-btn>
                    </v-col>
                </v-row>
            </v-alert>

            <!--Login form-->
            <v-card>
                <v-card-title class="word-wrap">Se connecter à Yodaforex</v-card-title>
                <v-container class="pa-sm-8">
                    <v-form @focus="authFailed=false" @input="authFailed=false" @submit.prevent="authenticate"
                            ref="loginForm" v-model="isFormValid">
                        <v-row>
                            <v-col>
                                <v-text-field :disabled="loading"
                                              :rules="[v => !!v || 'L\'email est obligatoire']"
                                              class="thin-outlined" hide-details
                                              label="Email" outlined v-model="login"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                                              :disabled="loading" :type="hidePassword ? 'password' : 'text'"
                                              :rules="[v => !!v || 'Le mot de passe est obligatoire']"
                                              @click:append="() => (hidePassword = !hidePassword)" class="thin-outlined"
                                              hide-details label="Mot de passe" outlined required v-model="password"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox :disabled="loading" hide-details label="Rester connecté"
                                            v-model="stayConnected"/>
                            </v-col>
                        </v-row>

                        <v-row class="mt-4">
                            <v-col>
                                <v-btn :disabled="!isFormValid" :loading="loading" @click="authenticate"
                                       block
                                       color="success" type="submit">
                                    Connexion
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-divider class="ma-6"/>

                    <v-row justify="center">
                        <router-link class="blue-grey--text help-connect-link mb-3" to="/forgot">J'ai oublié mon mot de
                            passe
                        </router-link>
                    </v-row>
                    <v-row justify="center">
                        <a class="blue-grey--text help-connect-link mb-3" href="">Je recontre des difficultés pour me
                            connecter</a>
                    </v-row>

                </v-container>
            </v-card>
        </div>
    </v-container>
</template>

<script>
	export default {
		name: "LoginView",
		data() {
			return {
				login: "",
				password: "",
				hidePassword: true,
				stayConnected: true,
				isFormValid: false,
				isAuthenticating: false,
				authFailed: false,
				userIsBlocked: false,
				userIsInPasswordRecovery: false,
				forgotPasswordAlert: false,
				unknownError: false,
				isSuccess: false,
				isRedirecting: false,
				successiveAttempts: 0,
				resendingResetCode: false,
				isResentResetCodeSuccess: false
			}
		},
		computed: {
			loading() {
				return this.isRedirecting || this.isAuthenticating;
			}
		},
		mounted() {
			if (this.$route.params.login) {
				this.login = this.$route.params.login;
			}
		},
		methods: {
			authenticate() {
				this.unknownError = false;
				if (this.$refs.loginForm.validate()) {
					this.isAuthenticating = true;
					this.authFailed = false;
					this.$http.post(this.$config.apiUrl + "/v2/auth/user", {
						email: this.login,
						password: this.password,
						stayConnected: this.stayConnected
					})
						.then(r => {
							this.isSuccess = true;
							this.handleSuccess(r);
						})
						.catch(e => {
							if (e.response && e.response.status === 401) {
								if (e.response.data.reason === "IN_PWD_RECOVERY") {
									this.userIsInPasswordRecovery = true;
								} else if (e.response.data.reason === "BLOCKED") {
									this.userIsBlocked = true;
								} else {
									this.authFailed = true;
									if (++this.successiveAttempts > 2) {
										this.forgotPasswordAlert = true;
									}
								}
							} else {
								this.unknownError = true;
							}
						})
						.finally(() => this.isAuthenticating = false)
				}
			},
			handleSuccess(response) {
        let cookie = "Yfx-Session=" + response.data.sessionToken + "; Domain=" + this.$config.authConfig.sessionTokenCookieDomain;
        if (this.stayConnected) {
          // Si l'utilisateur demande à rester connecté, le cookie expirera dans 1 an
          let now = new Date();
          now.setFullYear(now.getFullYear() + 1, now.getMonth(), now.getDate());
          cookie += "; Expires=" + now.toUTCString();
        }
        document.cookie = cookie;
				let currentUrl = new URL(window.location.origin + window.location.hash.substring(1));
				let redirect = currentUrl.searchParams.get('redirect');
				let path = redirect ? redirect : (response.data.suggestedRedirection ? response.data.suggestedRedirection : this.$config.successRedirectionFallback)
				this.$router.push({name: 'success', params: {redirect: path}});
			}
		}
	}
</script>

<style scoped>
    .word-wrap {
        word-break: normal;
    }

    .centered-content {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }

    .help-connect-link {
        font-size: smaller;
        text-decoration: none;
    }

</style>
